import React, { useState } from "react";
import FontAwesome from "react-fontawesome";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { TicketFieldSetting } from "src/sdk/models/Organisation";

interface DropdownFieldSettingProps {
  values: TicketFieldSetting;
  onEditField: (values: TicketFieldSetting) => void;
}

const DropdownFieldSetting: React.FC<DropdownFieldSettingProps> = ({ values, onEditField }) => {
  const [menu, setMenu] = useState(false);
  const [name, setName] = useState("Options");

  const editField = () => {
    if (onEditField) onEditField(values);
  };

  return (
    <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
      <DropdownToggle
        className="btn header-item bg-soft-light"
        id="page-header-user-dropdown"
        tag="button"
      >
        <FontAwesome name="caret-down" />
        <span className="d-none d-xl-inline-block ms-2 me-1">{name}</span>
      </DropdownToggle>
      <DropdownMenu
        className="dropdown-menu-end"
        style={{ width: "150px" }}
        container="body"
      >
        <div className="dropdown-item" onClick={editField}>
          <i className="bx bx-edit-alt font-size-16 align-middle me-1" />
          <span>Edit</span>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default DropdownFieldSetting;
